var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "groupBuying f16 seller-style" },
    [
      _c(
        "div",
        {
          staticClass: "lin_15 f16 gray_3 fb",
          staticStyle: { width: "120px", "margin-left": "30px" }
        },
        [_c("el-button", { on: { click: _vm.doCancel } }, [_vm._v("< 返回")])],
        1
      ),
      _c("div", { staticClass: "box20" }),
      _c(
        "div",
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.activity,
                "label-width": "120px",
                "label-suffix": "："
              }
            },
            [
              _c(
                "el-form-item",
                { staticClass: "is-required", attrs: { label: "活动商品" } },
                [
                  !_vm.isEdit
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "group_btn b_primary white f14 t_center mar20-b",
                          on: { click: _vm.selectGoodsList }
                        },
                        [_vm._v("点击添加商品")]
                      )
                    : _vm._e(),
                  _vm.checkGoodsList.length
                    ? _c(
                        "el-table",
                        {
                          staticClass: "check-table",
                          attrs: {
                            data: _vm.checkGoodsList,
                            "tooltip-effect": "dark"
                          }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "picUrl",
                              label: "商品图片",
                              width: "120"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("img", {
                                        staticClass: "goodImg",
                                        attrs: { src: scope.row.picUrl }
                                      })
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1764364089
                            )
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "name",
                              label: "商品名称",
                              "min-width": "20%"
                            }
                          }),
                          !_vm.isEdit
                            ? _c("el-table-column", {
                                attrs: { label: "操作", width: "180" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "info",
                                                plain: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.removeCheckGoods(
                                                    scope.$index
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("删除")]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1182613866
                                )
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "is-required", attrs: { label: "答疑" } },
                [
                  !_vm.isEdit
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "group_btn b_primary white f14 t_center mar20-b",
                          on: { click: _vm.addGoodsDy }
                        },
                        [_vm._v("添加答疑")]
                      )
                    : _vm._e(),
                  _c(
                    "el-form",
                    {
                      ref: "checkDtlList",
                      staticClass: "demo-dynamic",
                      attrs: { "label-width": "100px" }
                    },
                    [
                      _vm._l(_vm.checkDtlList, function(item) {
                        return _vm.checkDtlList.length
                          ? [
                              _c(
                                "div",
                                { staticStyle: { overflow: "hidden" } },
                                [
                                  _c("div", { staticClass: "box20" }),
                                  _c(
                                    "div",
                                    { staticClass: "anserDiv" },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "is-required",
                                          attrs: {
                                            prop: "question",
                                            label: "问题:"
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            staticStyle: { width: "90%" },
                                            attrs: {
                                              type: "text",
                                              placeholder: "请输入问题",
                                              maxlength: "30",
                                              "show-word-limit": "",
                                              size: "medium"
                                            },
                                            on: { change: _vm.hadChange },
                                            model: {
                                              value: item.question,
                                              callback: function($$v) {
                                                _vm.$set(item, "question", $$v)
                                              },
                                              expression: "item.question"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "is-required",
                                          attrs: {
                                            prop: "answer",
                                            label: "回答:"
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            staticStyle: { width: "90%" },
                                            attrs: {
                                              type: "textarea",
                                              placeholder: "请输入回答",
                                              rows: 4,
                                              maxlength: "100",
                                              "show-word-limit": "",
                                              size: "medium"
                                            },
                                            on: { change: _vm.hadChange },
                                            model: {
                                              value: item.answer,
                                              callback: function($$v) {
                                                _vm.$set(item, "answer", $$v)
                                              },
                                              expression: "item.answer"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            prop: "personAmount",
                                            label: "同问人数:"
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            staticStyle: { width: "90%" },
                                            attrs: {
                                              placeholder: "请输入同问人数",
                                              oninput:
                                                "value=value.replace(/[^\\d]/g, '').replace(/^0+(\\d)/, '$1').replace(/(\\d{9})\\d*/, '$1')",
                                              size: "medium"
                                            },
                                            on: { change: _vm.hadChange },
                                            model: {
                                              value: item.personAmount,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  item,
                                                  "personAmount",
                                                  $$v
                                                )
                                              },
                                              expression: "item.personAmount"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "is-required",
                                          attrs: {
                                            prop: "top",
                                            label: "是否精选:"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            {
                                              attrs: { label: true },
                                              on: { change: _vm.hadChange },
                                              model: {
                                                value: item.top,
                                                callback: function($$v) {
                                                  _vm.$set(item, "top", $$v)
                                                },
                                                expression: "item.top"
                                              }
                                            },
                                            [_vm._v("是")]
                                          ),
                                          _c(
                                            "el-radio",
                                            {
                                              attrs: { label: false },
                                              on: { change: _vm.hadChange },
                                              model: {
                                                value: item.top,
                                                callback: function($$v) {
                                                  _vm.$set(item, "top", $$v)
                                                },
                                                expression: "item.top"
                                              }
                                            },
                                            [_vm._v("否")]
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "is-required",
                                          attrs: {
                                            prop: "show",
                                            label: "是否展示:"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            {
                                              attrs: { label: true },
                                              on: { change: _vm.hadChange },
                                              model: {
                                                value: item.show,
                                                callback: function($$v) {
                                                  _vm.$set(item, "show", $$v)
                                                },
                                                expression: "item.show"
                                              }
                                            },
                                            [_vm._v("是")]
                                          ),
                                          _c(
                                            "el-radio",
                                            {
                                              attrs: { label: false },
                                              on: { change: _vm.hadChange },
                                              model: {
                                                value: item.show,
                                                callback: function($$v) {
                                                  _vm.$set(item, "show", $$v)
                                                },
                                                expression: "item.show"
                                              }
                                            },
                                            [_vm._v("否")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm.checkDtlList.length > 1
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              staticClass: "anserDelDiv",
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.removeDtl(item)
                                                }
                                              }
                                            },
                                            [_vm._v("删除")]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              )
                            ]
                          : _vm._e()
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _c("el-form-item", [
                _vm.isEnd
                  ? _c(
                      "div",
                      { staticClass: "t_center w840" },
                      [
                        _c("el-button", { on: { click: _vm.toList } }, [
                          _vm._v("返回")
                        ])
                      ],
                      1
                    )
                  : _c(
                      "div",
                      { staticClass: "t_center w840" },
                      [
                        _c("el-button", { on: { click: _vm.doCancel } }, [
                          _vm._v("取消")
                        ]),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.onSubmit }
                          },
                          [_vm._v("确认")]
                        )
                      ],
                      1
                    )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择商品",
            visible: _vm.chooseGoodVisible,
            "close-on-click-modal": false,
            width: "800px"
          },
          on: {
            "update:visible": function($event) {
              _vm.chooseGoodVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "div",
                { staticClass: "pad20_b" },
                [
                  _c("el-input", {
                    staticClass: "mar10-r",
                    attrs: { placeholder: "请输入商品名称" },
                    model: {
                      value: _vm.searchName,
                      callback: function($$v) {
                        _vm.searchName = $$v
                      },
                      expression: "searchName"
                    }
                  }),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.goodSearch }
                    },
                    [_vm._v("搜 索")]
                  )
                ],
                1
              ),
              _c(
                "el-table",
                {
                  ref: "multipleTable",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.goodsDataList,
                    "row-key": "spuId",
                    "max-height": "400"
                  },
                  on: { "selection-change": _vm.handleSelectionChange }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "selection",
                      "reserve-selection": true,
                      width: "55",
                      selectable: _vm.selectable
                    }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "picUrl", label: "商品图片", width: "220" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("img", {
                              staticClass: "goodImg",
                              attrs: { src: scope.row.picUrl }
                            })
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "name", label: "商品名称" }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "activityUsed", label: "" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.activityUsed === true
                              ? _c(
                                  "span",
                                  { staticStyle: { color: "#d7d7d7" } },
                                  [_vm._v("已添加")]
                                )
                              : _c("span")
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.goodsDialogCancel } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.goodsDialogConfirm }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }